<div class="w-full bg-black/80 mx-auto items-center justify-center fixed z-50 py-1">
    <div class="w-full lg:w-4/5 mx-auto ">
        <div class="flex xl:items-center xl:justify-center bg-black/0 shadow-sm z-50">
            <div class="flex w-full md:w-4/5 xl:w-1/6">
                <div class="my-3 dropdown">
                    <div tabindex="0" role="button" class="btn btn-ghost xl:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"> <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /> </svg>
                    </div>
                    <ul
                        tabindex="0"
                        class="menu menu-sm dropdown-content bg-black rounded-b-box z-1 mt-3 w-52 p-2 shadow">
                        <!-- <li><a href="/about-us" routerLink="/about-us">{{texts.about_us}}</a></li> -->
                        <li>
                            <a>{{texts.llantas.title}}</a>
                            <ul class="p-2">
                                <li class="mb-3">
                                    <a class="flex items-center" href="/tires/vehicle-type/electric-vehicle" routerLink="/tires/vehicle-type/electric-vehicle">
                                        <span class="flex items-center">
                                            <img src="src/assets/tire.svg" alt="auto electrico" srcset="" class="w-5 h-5 mr-2">
                                            {{texts.llantas.subtitle}}
                                        </span>
                                        
                                    </a>
                                </li>
                            
                                <hr class="bg-green-500">
                                <li><a href="tires/product/xnex-sport-ev" routerLink="tires/product/xnex-sport-ev">XNEX Sport EV</a></li>
                                <li><a href="tires/product/xlab-comfort-ev" routerLink="tires/product/xlab-comfort-ev">XLAB Confort EV</a></li>
                                <!-- <li><a href="https://mundoev.com/229-cargadores" target="_blank">{{texts.llantas.charger_title}}</a></li> -->
                            </ul>
                        </li>
                        <li>
                            <a>{{texts.information.title}}</a>
                            <ul class="p-2">
                                <li><a href="/excellence/technology/" routerLink="/excellence/technology/">{{texts.information.tecnologia}}</a></li>
                                <li><a href="/excellence/awards/" routerLink="/excellence/awards/">{{texts.information.premios}}</a></li>
                                <li><a href="/excellence/tire-knowledge/" routerLink="/excellence/tire-knowledge/">{{texts.information.informacion}}</a></li>
                                <li><a href="/excellence/tuv-sud/" routerLink="/excellence/tuv-sud/">{{texts.information.tuv_sud}}</a></li>
                            </ul>
                        </li>
                        <div class="dropdown">
                        <li class="mx-5">
                            <a tabindex="1" class="text-base">
                                @if (getLanguage() == 'es') {
                                    <span>
                                        <img src="/src/assets/img/es.svg" alt="español" class="w-4 h-4 mr-2">
                                    </span>
                                    Español
                                }
                                @else {
                                    <span>
                                        <img src="/src/assets/img/en.svg" alt="español" class="w-4 h-4 mr-2">
                                    </span>
                                    English
                                }
                            </a>
                        </li>
                        <ul tabindex="1" class="dropdown-content menu bg-black rounded-b-box z-1 w-64 mx-5 p-2 shadow-sm">
                            @if (getLanguage() == 'es') {
                                <li>
                                    <a (click)="setLanguage('en')" class="text-base">
                                        <span>
                                            <img src="/src/assets/img/en.svg" alt="español" class="w-4 h-4 mr-2">
                                        </span>
                                        English
                                    </a>
                                </li>
                            }
                            @else {
                                <li>
                                    <a (click)="setLanguage('es')" class="text-base">
                                        <span>
                                            <img src="/src/assets/img/es.svg" alt="español" class="w-4 h-4 mr-2">
                                        </span>
                                        Español
                                    </a>
                                </li>
                            }
                            
                            
                        </ul>
                    </div>
                        <!-- <li>
                            <a>Noticias y medios de comunicación</a>
                            <ul class="p-2">
                                <li><a>Sala de prensa</a></li>
                                <li><a>Tire Cologne 24</a></li>
                            </ul>
                        </li> -->
                        
                    </ul>
                </div>
                <a class="lg:items-center lg:justify-center" href="/">
                  <img src="/assets/logo.webp" class="w-32 lg:w-36 xl:w-full my-2" alt="" srcset="">  
                </a>
                
            </div>
            <div class="w-full hidden xl:flex items-center justify-center">
                
                <ul class="menu menu-horizontal px-3 items-center justify-center">
                    <!-- <li class="mx-5"><a class="text-base" href="/about-us" routerLink="/about-us">{{texts.about_us}}</a></li> -->
                    <div class="dropdown">
                        <li class="mx-5"><a tabindex="0" class="text-base">{{texts.llantas.title}}</a></li>
                        <ul tabindex="0" class="dropdown-content menu bg-black rounded-b-box z-1 w-64 mx-5 p-2 shadow-sm">
                            <li class="font-bold">{{texts.llantas.section}}</li>
                            <li class="mb-3">
                                <a class="flex items-center" href="/tires/vehicle-type/electric-vehicle" routerLink="/tires/vehicle-type/electric-vehicle">
                                    <span class="flex items-center">
                                        <img src="src/assets/tire.svg" alt="auto electrico" srcset="" class="w-5 h-5 mr-2">
                                        {{texts.llantas.subtitle}}
                                    </span>
                                    
                                </a>
                            </li>
                        
                            <hr class="bg-green-500">
                            <li><a href="tires/product/xnex-sport-ev" routerLink="tires/product/xnex-sport-ev">XNEX Sport EV</a></li>
                            <li><a href="tires/product/xlab-comfort-ev" routerLink="tires/product/xlab-comfort-ev">XLAB Confort EV</a></li>
                            <!-- <li><a href="https://mundoev.com/229-cargadores" target="_blank">{{texts.llantas.charger_title}}</a></li> -->
                        </ul>
                    </div>

                    <div class="dropdown">
                        <li class="mx-5"><a tabindex="1" class="text-base">{{texts.information.title}}</a></li>
                        <ul tabindex="1" class="dropdown-content menu bg-black rounded-b-box z-1 w-64 mx-5 p-2 shadow-sm">
                            <li><a href="/excellence/technology/" routerLink="/excellence/technology/">{{texts.information.tecnologia}}</a></li>
                            <li><a href="/excellence/awards/" routerLink="/excellence/awards/">{{texts.information.premios}}</a></li>
                            <li><a href="/excellence/tire-knowledge/" routerLink="/excellence/tire-knowledge/">{{texts.information.informacion}}</a></li>
                            <li><a href="/excellence/tuv-sud/" routerLink="/excellence/tuv-sud/">{{texts.information.tuv_sud}}</a></li>
                        </ul>
                    </div>

                    <div class="dropdown">
                        <li class="mx-5">
                            <a tabindex="1" class="text-base">
                                @if (getLanguage() == 'es') {
                                    <span>
                                        <img src="/src/assets/img/es.svg" alt="español" class="w-4 h-4 mr-2">
                                    </span>
                                    Español
                                }
                                @else {
                                    <span>
                                        <img src="/src/assets/img/en.svg" alt="español" class="w-4 h-4 mr-2">
                                    </span>
                                    English
                                }
                            </a>
                        </li>
                        <ul tabindex="1" class="dropdown-content menu bg-black rounded-b-box z-1 w-64 mx-5 p-2 shadow-sm">
                            @if (getLanguage() == 'es') {
                                <li>
                                    <a (click)="setLanguage('en')" class="text-base">
                                        <span>
                                            <img src="/src/assets/img/en.svg" alt="español" class="w-4 h-4 mr-2">
                                        </span>
                                        English
                                    </a>
                                </li>
                            }
                            @else {
                                <li>
                                    <a (click)="setLanguage('es')" class="text-base">
                                        <span>
                                            <img src="/src/assets/img/es.svg" alt="español" class="w-4 h-4 mr-2">
                                        </span>
                                        Español
                                    </a>
                                </li>
                            }
                            
                            
                        </ul>
                    </div>

                    <!-- <div class="dropdown">
                        <li class="mx-5"><a tabindex="2" class="text-base text-center">Noticias y medios<br> de comunicación</a></li>
                        <ul tabindex="2" class="dropdown-content menu bg-black rounded-b-box z-1 w-64 mx-5 p-2 shadow-sm">
                            <li><a>Sala de prensa</a></li>
                            <li><a>Tire Cologne 24</a></li>
                        </ul>
                    </div> -->
                    

                    
                </ul>
                
            </div>
            <div class="flex w-3/5 md:w-1/5 items-center justify-center animate-fade-left animate-ease-in">
                    <div class="flex items-center justify-center">
                        <a href="https://mundoev.com?utm_source=prinxcr&utm_medium=referral&utm_campaign=prinx_referred" target="_blank" rel="noopener noreferrer">
                            <button class="py-5 px-8 md:py-6 md:px-6 cursor-pointer inline-flex items-center justify-center h-4 lg:h-10 gap-2 text-sm
                            font-medium tracking-wide transition duration-300 border rounded-full shadow-sm focus-visible:outline-none whitespace-nowrap 
                            border-green-500 text-green-500 shadow-green-200 hover:border-green-600 hover:text-green-600 focus:border-green-700 
                            focus:text-green-700 hover:shadow-sm hover:shadow-green-200 focus:shadow-sm focus:shadow-green-200 disabled:cursor-not-allowed 
                            disabled:border-green-300 disabled:text-green-300 disabled:shadow-none">
                                <div class="inline-flex w-6 h-6 items-center justify-center">
                                    <img src="/assets/tire.svg" alt="" srcset="">
                                </div>
                                <div>
                                    <span class="text-white text-xs uppercase">{{texts.comprar_btn[0]}} <br> {{texts.comprar_btn[1]}} </span>
                                </div>
                            </button>
                        </a>
                    </div>
            </div>
        </div>
    </div>
</div>

<div class="">
    <a href="https://wa.me/50688979888" target="_blank" rel="noopener noreferrer">
        <button class="z-50 hover:cursor-pointer animate-fade-up animate-ease-in fixed bottom-35 right-6 w-16 h-16 mx-2 inline-flex items-center justify-center gap-2 text-sm 
                                font-medium tracking-wide transition duration-300 rounded-full focus-visible:outline-none 
                                justify-self-center whitespace-nowrap bg-green-500 hover:bg-green-500 
                                hover:text-green-600 focus:bg-green-500 focus:text-green-700 disabled:cursor-not-allowed 
                                disabled:border-green-500 disabled:bg-green-500 disabled:text-green-400 disabled:shadow-none
                                hover:scale-110">
                                    <span class="w-14 h-14 p-1">
                                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6.014 8.00613C6.12827 7.1024 7.30277 5.87414 8.23488 6.01043L8.23339 6.00894C9.14051 6.18132 9.85859 7.74261 10.2635 8.44465C10.5504 8.95402 10.3641 9.4701 10.0965 9.68787C9.7355 9.97883 9.17099 10.3803 9.28943 10.7834C9.5 11.5 12 14 13.2296 14.7107C13.695 14.9797 14.0325 14.2702 14.3207 13.9067C14.5301 13.6271 15.0466 13.46 15.5548 13.736C16.3138 14.178 17.0288 14.6917 17.69 15.27C18.0202 15.546 18.0977 15.9539 17.8689 16.385C17.4659 17.1443 16.3003 18.1456 15.4542 17.9421C13.9764 17.5868 8 15.27 6.08033 8.55801C5.97237 8.24048 5.99955 8.12044 6.014 8.00613Z" fill="#FFF"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M12 23C10.7764 23 10.0994 22.8687 9 22.5L6.89443 23.5528C5.56462 24.2177 4 23.2507 4 21.7639V19.5C1.84655 17.492 1 15.1767 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM6 18.6303L5.36395 18.0372C3.69087 16.4772 3 14.7331 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C11.0143 21 10.552 20.911 9.63595 20.6038L8.84847 20.3397L6 21.7639V18.6303Z" fill="#FFF"></path> </g></svg>                                    </span>
                                </button>
    </a>

    <a href="https://mundoev.com?utm_source=prinxcr&utm_medium=referral&utm_campaign=llantas" target="_blank" rel="noopener noreferrer">
        <button
            class="hover:cursor-pointer animate-fade-up animate-ease-in fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg p-4 flex items-center justify-center transition-all duration-200 hover:scale-110"
            style="box-shadow: 0 4px 16px rgba(0,0,0,0.2);"
            aria-label="buy tire">
            
            <svg viewBox="-0.5 0 25 25" class="h-12 w-12 xl:h-18 xl:w-18 text-white" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"> <path d="M18.5996 21.57C19.7042 21.57 20.5996 20.6746 20.5996 19.57C20.5996 18.4654 19.7042 17.57 18.5996 17.57C17.495 17.57 16.5996 18.4654 16.5996 19.57C16.5996 20.6746 17.495 21.57 18.5996 21.57Z" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> 
                    <path d="M8.59961 21.57C9.70418 21.57 10.5996 20.6746 10.5996 19.57C10.5996 18.4654 9.70418 17.57 8.59961 17.57C7.49504 17.57 6.59961 18.4654 6.59961 19.57C6.59961 20.6746 7.49504 21.57 8.59961 21.57Z" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> 
                    <path d="M2 3.55997C2 3.55997 6.64 3.49997 6 7.55997L5.31006 11.62C5.20774 12.1068 5.21778 12.6105 5.33954 13.0929C5.46129 13.5752 5.69152 14.0234 6.01263 14.4034C6.33375 14.7833 6.73733 15.0849 7.19263 15.2854C7.64793 15.4858 8.14294 15.5797 8.64001 15.56H16.64C17.7479 15.5271 18.8119 15.1196 19.6583 14.404C20.5046 13.6884 21.0834 12.7069 21.3 11.62L21.9901 7.50998C22.0993 7.0177 22.0939 6.50689 21.9744 6.017C21.8548 5.52712 21.6242 5.07126 21.3005 4.68467C20.9767 4.29807 20.5684 3.99107 20.1071 3.78739C19.6458 3.58371 19.1438 3.48881 18.64 3.50998H9.94" stroke="#FFF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
        </button>
    </a>
    
</div>

